import Footer from 'components/Footer';
import LogoLoader from 'components/LogoLoader';
import Head from 'next/head';
import React from 'react';
import ClubQuickLinks from '../Dashboard/ClubQuickLinks';
import { NavbarPages } from '../ui/Navbar/NavbarPages';

interface Props {
    title?: string;
    metaDescription?: string;
    isLoading?: boolean;
    withoutContainer?: boolean;
    withoutFooter?: boolean;
    spacing?: number;
    authRequired?: boolean;
}

export const NextLayout: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
    title,
    metaDescription,
    children,
    isLoading,
    withoutContainer,
    withoutFooter,
    authRequired,
    spacing = 0
}) => {
    return (
        <>
            <Head>
                {title && <title>{title}</title>}
                {metaDescription && <meta name="description" content={metaDescription} />}
                <meta name="viewport" content="initial-scale=1.0, width=device-width" key="viewport" />
            </Head>
            <NavbarPages />

            {spacing ? <div style={{ height: spacing * 8 + 'px' }} /> : null}
            <div
                className={`tw-relative tw-z-0 tw-h-px tw-min-h-[calc(100vh-88px-15.25rem-1px)] tw-px-0 ${isLoading && 'tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center'}`}
            >
                {withoutContainer ? children : isLoading ? <LogoLoader /> : children}
                <ClubQuickLinks />
                {!withoutFooter && <Footer />}
            </div>
        </>
    );
};
